// `:id` is a conversation id, passed through as `item=` unchanged. This depends on nexus#2111:
// its GET /feedback_inbox/:id accepts an order_rating hashid or a conversation id and resolves
// the rating server-side. Until #2111 ships, the endpoint does not exist and this link 404s.
import useFlag from 'hooks/useFlag'
import React from 'react'
import type { StaticContext } from 'react-router'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import CaseDetail from './CaseDetail'

// Mirrors CaseDetail's own (unexported) LocationState so `{...props}` below
// satisfies its Props type — the escalationId router state CaseDetail reads
// on a direct /cases/:id visit (see CaseDetail/index.tsx).
type LocationState = { escalationId?: string }

const CaseDetailOrInboxRedirect = (
  props: RouteComponentProps<{ id: string }, StaticContext, LocationState>
) => {
  const unifiedInboxEnabled = useFlag(
    'recovery-ai-unified-feedback-inbox',
    false
  )
  if (unifiedInboxEnabled) {
    return (
      <Redirect to={`/recovery_ai/escalations?item=${props.match.params.id}`} />
    )
  }
  return <CaseDetail {...props} />
}

export default CaseDetailOrInboxRedirect
